import { useEffect } from 'react';

export const useAutoRefresh = (refreshFn, { enabled = true, intervalMs = 10000 } = {}) => {
  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    const refreshIfVisible = () => {
      if (document.visibilityState === 'visible') {
        refreshFn();
      }
    };

    const intervalId = window.setInterval(refreshIfVisible, intervalMs);

    const handleFocus = () => {
      refreshFn();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        refreshFn();
      }
    };

    window.addEventListener('focus', handleFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener('focus', handleFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [refreshFn, enabled, intervalMs]);
};
